var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7359 52.798L53.6671 41.7706C55.6796 37.7606 57.0213 33.0823 57.0213 28.404C57.0213 12.6983 44.2753 0 28.5106 0C12.7459 0 0 12.6983 0 28.404C0 44.1097 12.7459 56.808 28.5106 56.808C33.2065 56.808 37.9024 55.4713 41.9274 53.4663L52.9962 64.4938C56.3504 67.8354 61.3817 67.8354 64.7359 64.4938C67.7547 61.1521 67.7547 56.1397 64.7359 52.798ZM28.5106 50.1247C16.4355 50.1247 6.70839 40.4339 6.70839 28.404C6.70839 16.3741 16.4355 6.68329 28.5106 6.68329C40.5857 6.68329 50.3129 16.3741 50.3129 28.404C50.3129 40.4339 40.5857 50.1247 28.5106 50.1247Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer);
export default __webpack_public_path__ + "static/media/ser.fa698fd5867f5e02463ef2d4df3ed4f7.svg";
export { ForwardRef as ReactComponent };